import React from "react";
import {
  basic_monthly,
  basic_yearly
} from "../../constants/subscription_products";

export default function PaymentPlans({
  product,
  setProduct
}) {
  return (
    <div className="signup-payment-plans">
      <div className="title">Payment Plans</div>
      <div className="plan-title">
        Basic Professional Plans
      </div>
      <div className="plan-price">
        <input
          type="radio"
          name="products"
          id="basic-monthly"
          checked={product === basic_monthly}
          value={basic_monthly}
          onChange={e => setProduct(e.target.value)}
        />
        <label htmlFor="basic-monthly">
          Monthly $25.00
        </label>
      </div>
      <div className="plan-price">
        <input
          type="radio"
          name="products"
          id="basic-yearly"
          checked={product === basic_yearly}
          value={basic_yearly}
          onChange={e => setProduct(e.target.value)}
        />
        <label htmlFor="basic-yearly">
          Annual $275.00
          <br/>
          With the Annual Plan, you receive 1 month Free.
        </label>
      </div>
      <div>
        At the end of a LANIS Demo or webinar you&rsquo;ll receive a 30-Day FREE Trial promo code &mdash; enter it below, no credit card needed.
      </div>
    </div>
  );
}
